export const withPrefilledOption = (options, id, label) => {
    if (!id || !label) return options;
    const exists = options.some(opt => opt.value === id);
    return exists ? options : [...options, {value: id, label}];
};

export function formatTerminalOrder(
    terminalId,
    orderNumber
) {
    // treat null, undefined, empty string, or 0 as "no order"
    if (!orderNumber || Number(orderNumber) === 0) {
        return `${terminalId} / 000000`;
    }

    const paddedOrder = String(orderNumber).padStart(6, '0');
    return `${terminalId} / ${paddedOrder}`;
}

export function deviceTempColor(temp) {
    if (temp === null || temp === undefined) {
        return 'geekblue';
    }
    if (temp >= 0 && temp <= 39) {
        return 'cyan';
    }
    if (temp >= 40 && temp <= 49) {
        return 'green';
    }
    if (temp >= 50 && temp <= 59) {
        return 'orange';
    }
    return 'red';
}
